var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyticsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.5C1 1.94772 1.44772 1.5 2 1.5H22C22.5523 1.5 23 1.94772 23 2.5V21.086C23 21.1569 22.9926 21.2261 22.9786 21.2929C22.9926 21.3597 23 21.429 23 21.5C23 22.0523 22.5523 22.5 22 22.5H6.5078C5.95552 22.5 5.5078 22.0523 5.5078 21.5C5.5078 20.9477 5.95552 20.5 6.5078 20.5H21V9.5H3V15.0859C3 15.6382 2.55228 16.0859 2 16.0859C1.44772 16.0859 1 15.6382 1 15.0859V2.5ZM3 7.5V3.5H21V7.5H3ZM14.6926 12.7923C15.0797 12.4058 15.7055 12.4021 16.0972 12.784L18.3374 14.968C18.7329 15.3535 18.7409 15.9866 18.3554 16.3821C17.9699 16.7775 17.3367 16.7856 16.9413 16.4L15.4075 14.9047L12.084 18.2227C11.6993 18.6068 11.0784 18.6132 10.6858 18.2373L8.10655 15.7672L2.71071 21.2185C2.32219 21.611 1.68904 21.6143 1.29652 21.2258C0.904003 20.8372 0.900764 20.2041 1.28929 19.8116L7.37709 13.6612C7.76108 13.2732 8.38523 13.2649 8.77946 13.6424L11.3629 16.1165L14.6926 12.7923Z",
    fill: "currentColor",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.01c8e2d64a9a01b6917d23e7c8f75dd8.svg";
export { ForwardRef as ReactComponent };